function escapeHtml(str) {
  if(!str) return '';
  return String(str)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}

function getPrimaryColorFallback() {
  const v = getComputedStyle(document.documentElement).getPropertyValue('--primarycolor').trim();
  return v || '#000000';
}

function genreColor(f, fallback) {
  if(f && f.genre && f.genre.length) {
    const found = f.genre.find((g) => g && g.color);
    if(found) return found.color;
  }
  return fallback;
}

const PIN_SCALE_DEFAULT = 1.5;
const PIN_SCALE_HOVER = 2.2;

function pinIcon(color, scale) {
  return {
    path: 'M 0 0 C -2 -16 -10 -18 -10 -26 A 10 10 0 1 1 10 -26 C 10 -18 2 -16 0 0 Z',
    fillColor: color,
    fillOpacity: 1,
    strokeColor: '#ffffff',
    strokeWeight: 2,
    scale: typeof scale === 'number' ? scale : PIN_SCALE_DEFAULT,
    anchor: new google.maps.Point(0, 0)
  };
}

function initFriendsArchiveMap() {
  const el = document.querySelector('.js-friends-archive-map');
  if(!el || !window.google || !window.google.maps) return;
  if(typeof window.friendsData === 'undefined' || !window.friendsData) return;
  const fallbackColor = getPrimaryColorFallback();

  const map = new google.maps.Map(el, {
    mapTypeControl: false,
    streetViewControl: false,
    fullscreenControl: false,
    zoomControl: true,
    gestureHandling: 'greedy'
  });

  const bounds = new google.maps.LatLngBounds();
  const info = new google.maps.InfoWindow();
  const markersById = new Map();
  let pinCount = 0;

  window.friendsData.forEach((f) => {
    if(!f.googlemaps || !f.googlemaps.lat || !f.googlemaps.lng) return;
    const pos = { lat: parseFloat(f.googlemaps.lat), lng: parseFloat(f.googlemaps.lng) };
    if(isNaN(pos.lat) || isNaN(pos.lng)) return;

    bounds.extend(pos);
    pinCount++;

    const color = genreColor(f, fallbackColor);
    const marker = new google.maps.Marker({
      map,
      position: pos,
      title: f.title || '',
      icon: pinIcon(color)
    });
    markersById.set(String(f.id), { marker, color });

    marker.addListener('click', () => {
      const detailLabel = (typeof fabfLabels !== 'undefined' && fabfLabels.viewDetail) ? fabfLabels.viewDetail : '詳細を見る';
      const imgHtml = (f.images && f.images[0]) ? `<div class="friends-info-image"><img src="${escapeHtml(f.images[0])}" alt=""></div>` : '';
      const titleHtml = f.title ? `<p class="friends-info-title"><b>${escapeHtml(f.title)}</b></p>` : '';
      const addressHtml = f.address ? `<p class="friends-info-address">${escapeHtml(f.address).replace(/\n/g, '<br>')}</p>` : '';
      const html = `
        <div class="friends-info">
          ${imgHtml}
          ${titleHtml}
          ${addressHtml}
          <button type="button" class="friends-info-detail" data-friends-id="${escapeHtml(String(f.id))}">${escapeHtml(detailLabel)}</button>
        </div>`;
      info.setContent(html);
      info.open({ anchor: marker, map });
    });
  });

  if(pinCount > 0) {
    if(pinCount === 1) {
      map.setCenter(bounds.getCenter());
      map.setZoom(15);
    } else {
      map.fitBounds(bounds, { top: 60, right: 60, bottom: 60, left: 60 });
      google.maps.event.addListenerOnce(map, 'idle', () => {
        if(map.getZoom() > 17) map.setZoom(17);
      });
    }
  } else {
    // ピンが1件もない場合は日本中心の広域表示
    map.setCenter({ lat: 33.5904, lng: 130.4017 });
    map.setZoom(11);
  }

  // InfoWindow の「詳細を見る」ボタン → ドロワーを開く
  document.addEventListener('click', (e) => {
    const target = e.target.closest('.friends-info-detail');
    if(!target) return;
    const id = target.dataset.friendsId;
    if(!id) return;
    if(typeof window.openFriendsDrawer === 'function') {
      window.openFriendsDrawer(id);
      info.close();
    } else {
      const trigger = document.querySelector(`.friends-archive [data-friends-id="${id}"]`);
      if(trigger) trigger.click();
    }
  });

  // リスト項目ホバー → 該当ピンを強調
  document.querySelectorAll('.friends-archive [data-friends-id]').forEach((el) => {
    const id = el.dataset.friendsId;
    const entry = markersById.get(String(id));
    if(!entry) return;
    el.addEventListener('mouseenter', () => {
      entry.marker.setIcon(pinIcon(entry.color, PIN_SCALE_HOVER));
      entry.marker.setZIndex(google.maps.Marker.MAX_ZINDEX + 1);
    });
    el.addEventListener('mouseleave', () => {
      entry.marker.setIcon(pinIcon(entry.color));
      entry.marker.setZIndex(null);
    });
  });

  // 外部（friendsList）からピンの表示・非表示を切替
  window.setFriendsMapVisibility = (visibleIds) => {
    if(!visibleIds) {
      markersById.forEach(({ marker }) => marker.setMap(map));
      return;
    }
    const set = visibleIds instanceof Set ? visibleIds : new Set(Array.from(visibleIds, String));
    markersById.forEach(({ marker }, id) => {
      marker.setMap(set.has(String(id)) ? map : null);
    });
  };
}

function initFriendsSingleMap() {
  const el = document.querySelector('.js-friends-single-map');
  if(!el || !window.google || !window.google.maps) return;
  const lat = parseFloat(el.dataset.lat);
  const lng = parseFloat(el.dataset.lng);
  if(isNaN(lat) || isNaN(lng)) return;

  const color = el.dataset.color || getPrimaryColorFallback();
  const map = new google.maps.Map(el, {
    center: { lat, lng },
    zoom: 16,
    mapTypeControl: false,
    streetViewControl: false,
    fullscreenControl: false,
    gestureHandling: 'cooperative'
  });
  new google.maps.Marker({
    map,
    position: { lat, lng },
    title: el.dataset.title || '',
    icon: pinIcon(color)
  });
}

export function friendsMap() {
  const archiveEl = document.querySelector('.js-friends-archive-map');
  const singleEl = document.querySelector('.js-friends-single-map');
  if(!archiveEl && !singleEl) return;

  const tryInit = () => {
    if(window.google && window.google.maps) {
      if(archiveEl) initFriendsArchiveMap();
      if(singleEl) initFriendsSingleMap();
      return true;
    }
    return false;
  };

  if(tryInit()) return;
  window.addEventListener('googleMapsReady', () => {
    if(archiveEl) initFriendsArchiveMap();
    if(singleEl) initFriendsSingleMap();
  }, { once: true });
}
